import { useContext, useEffect, useState } from "react"
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import arquivoService from "services/ArquivoService"

import './ImagemArquivo.scss'
import AppContext from "AppContext"

export default function Imagem({ url, urlThumb, dadosLocalizacao, tituloModal, showEdit, onEdit }) {
  const [modal, setModal] = useState(false)
  const { state } = useContext(AppContext)

  const toggleModal = () => setModal(!modal)

  const handleEdit = ev => {
    ev.stopPropagation()
    onEdit && onEdit()
  }

  return (
    <>
      <div
        style={{
          width: 150,
          height: 150,
          border: '1px solid #ccc',
          borderRadius: 8,
          backgroundImage: `url(${urlThumb})`,
          backgroundSize: 'cover',
          cursor: 'pointer',
          position: "relative"
        }}
        onClick={toggleModal}
      >
        {(urlThumb && showEdit) && (
          <div style={{
            position: "absolute",
            width: 24,
            height: 24,
            padding: 2,
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 3,
            background: state.theme === 'dark' ? '#333' : 'white',
            top: 3,
            right: 3,
            cursor: 'pointer'
          }} onClick={handleEdit}>
            <i className="bi bi-pencil-fill"></i>
          </div>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggleModal} className="imagem-arquivo">
        <ModalHeader toggle={toggleModal} className="imagem-arquivo-header">{tituloModal}</ModalHeader>
        <ModalBody className="imagem-arquivo-body">
          <div style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
            <div>
              <img src={url} style={{
                maxWidth: '80vw',
                maxHeight: '80vh',
              }} />
            </div>
            <div>
              {dadosLocalizacao ? (
                <table>
                  <tbody>
                    <tr>
                      <th>Latitude: </th>
                      <td>{dadosLocalizacao.latitude}</td>
                    </tr>
                    <tr>
                      <th>Longitude: </th>
                      <td>{dadosLocalizacao.longitude}</td>
                    </tr>
                    {!!dadosLocalizacao.altitude && (
                      <tr>
                        <th>Elevação: </th>
                        <td>{dadosLocalizacao.altitude}±{dadosLocalizacao.precisaoAltitude}m</td>
                      </tr>
                    )}
                    {!!dadosLocalizacao.precisao && (
                      <tr>
                        <th>Precisão: </th>
                        <td>{dadosLocalizacao.precisao}m</td>
                      </tr>
                    )}
                    <tr>
                      <th>Endereço: </th>
                      <td>{dadosLocalizacao.endereco}</td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <div>Sem dados de localização</div>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}